// extracted by mini-css-extract-plugin
export default {"header":"Header_header__J+309","btn_login":"Header_btn_login__OqNMF","img_avatar":"Header_img_avatar__bnu3r","login_block":"Header_login_block__SC8eI"};